import React from 'react'
import { Redirect, Route } from 'react-router-dom'
// import decode from 'jwt-decode';
// import { isAuthenticated, authenticateUser } from './index'
import { useSelector } from 'react-redux';

const PublicRoute = ({ component: Component, ...rest }) => {
  const { user } = useSelector((state) => state.auth);


  return (
    <Route {...rest} render={props => {
      if (localStorage.getItem('token')) {
        // setExistingUserOnLogRocket();
        if (user.userType === 'admin' || user.userType === 'subadmin') {
          return <Redirect to={{ pathname: '/admin/dashboard', state: { from: props.location } }} />;
        }else {
          return <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />;
        }
      }
      return <Component {...props} />;
      }
    }
    />
  )
}
export default PublicRoute;





